import { render, staticRenderFns } from "./edittemplate.vue?vue&type=template&id=26c5b801"
import script from "./edittemplate.vue?vue&type=script&lang=js"
export * from "./edittemplate.vue?vue&type=script&lang=js"
import style0 from "./edittemplate.vue?vue&type=style&index=0&id=26c5b801&prod&scpoed=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports